module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete col-12"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('div', {
    staticClass: "input-group-append"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "search",
      "type": "search",
      "placeholder": "Practice name",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "focus": _vm.onFocus,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }, _vm.autoComplete],
      "blur": _vm.closeSuggestions
    }
  })]), _vm._v(" "), (_vm.showSuggestion) ? _c('ul', {
    staticClass: "text-left list-group autocomplete-list"
  }, _vm._l((_vm.suggestions), function(s) {
    return _c('li', {
      key: s.id,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.chosen(s)
        },
        "mousedown": function($event) {
          _vm.suggestionFocus = true
        }
      }
    }, [(s.logoImage) ? _c('img', {
      staticClass: "autocomplete-image",
      attrs: {
        "src": ("data:image/png;base64," + (s.logoImage))
      }
    }) : _c('img', {
      staticClass: "autocomplete-image",
      attrs: {
        "src": require("assets/images/logbox_logo_sm.png")
      }
    }), _vm._v("\n         " + _vm._s(s.name))])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c22ae14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputs/PracticeSearch.vue
// module id = 667
// module chunks = 5